import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const OwnerGuard = ({ children }) => {
  const { authenticated, role } = useAuth();

  if (!authenticated) {
    return <Navigate to="/login" />;
  }

  if (
    !["OWNER", "OWNERGROUP", "FLEET_MANAGER", "VESSEL_MANAGER"].includes(role)
  ) {
    return <Navigate to="/restricted-access" />;
  }

  return children;
};

export default OwnerGuard;
